import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
  templateUrl: './spo-train.component.html',
  standalone: false
})
export class SpoTrainPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  spoLockings: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.spoLockings = this.plugin.config.SpoLockings;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'spotrain',
      'edit'
    ];
  }
}

PluginComponent.plugins['spotrain'] = SpoTrainPluginComponent;
